export default __webpack_public_path__ + "static/media/SubWebPeople.be0f0362.png";